import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OrderBoxModule } from '../../orderBox';

import { OrderForConfirmationComponent } from './order-for-confirmation.shared.component';
import { BtnModule } from '@shared/core/components/buttons/btn/btn.shared.module';
import { OrderStatusModule } from '@shared/core/modules/order/components/orderStatus';

@NgModule({
    declarations: [
        OrderForConfirmationComponent
    ],
    imports: [
        CommonModule,
        OrderBoxModule,
        BtnModule,
        OrderStatusModule
    ],
    exports: [OrderForConfirmationComponent],
})

export class OrderTypeForConfirmationModule {}
